import { getRequest, postRequest } from "./client";
import { LoginPayload, VerifyEmailPayload } from "../hooks/useAuth";
import config from "environment";

const { baseApi } = config;

export enum AuthSource {
  STANDARD = "STANDARD",
  GOOGLE_AUTH = "GOOGLE_AUTH",
}

export const loginUser = async (payload: {
  email: string;
  passwordKey: string;
  authSource: AuthSource;
}): Promise<string | undefined> => {
  try {
    const response = await postRequest<LoginPayload, string | undefined>(
      "auth/login",
      payload,
      "API/loginUser"
    );

    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("AUTH LOGIN FAILED", error);
  }
  return;
};

export const verifyEmail = async (payload: VerifyEmailPayload) => {
  const result = await postRequest<VerifyEmailPayload, boolean>(
    "auth/verify-email",
    payload,
    "API/verifyEmail"
  );

  return result;
};

export async function apiAuthSendVerificationCode(email: string) {
  const fetchURL = `${baseApi}/auth/send-code/${email} `;
  return await getRequest(fetchURL, "API/apiAuthSendVerificationCode");
}

export async function apiAuthVerifyCode(email: string, code: string) {
  const fetchURL = `${baseApi}/auth/verify-code`;
  return await postRequest(fetchURL, { email, code }, "API/apiAuthVerifyCode");
}

export async function apiAuthDeleteUserCodes(id: string) {
  const fetchURL = `${baseApi}/auth/delete-codes/${id} `;
  return await getRequest(fetchURL, "API/apiAuthDeleteUserCodes");
}

export async function apiAuthUpdatePassword(
  email: string,
  password: string,
  code: string
) {
  const fetchURL = `${baseApi}/auth/update-password`;
  return await postRequest(
    fetchURL,
    { email, password, code },
    "API/apiAuthUpdatePassword"
  );
}

// export async function apiAuthValidatePassword (
//   email: string,
//   password: string,
// ) {
//   const fetchURL = `${baseApi}/auth/validate-password`;
//   return await postRequest(
//     fetchURL,
//     { email, password },
//     "API/apiAuthValidatePassword"
//   );
// }

export async function apiAuthChangePassword(
  email: string,
  oldPassword: string,
  newPassword: string
) {
  const fetchURL = `${baseApi}/auth/change-password`;
  return await postRequest(
    fetchURL,
    { email, oldPassword, newPassword },
    "API/apiAuthChangePassword"
  );
}

export async function apiAuthType(email: string) {
  const fetchURL = `${baseApi}/auth/type/${email} `;
  return await getRequest(fetchURL, "API/apiAuthType");
}
